import { Fragment, useEffect, useState } from 'react';

import { PetrolimexService as Service } from './PetrolimexService';
import { UnitService } from '../don-vi-tinh/UnitService';
import { TaxService } from '../thue-suat/TaxService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useImExExcel } from '../../../shared/hooks/ImExExcel';
import { FormatDisplay } from '../../../shared/format';
import { ConfirmDialogService } from '../../../AppConfirmDialog';
import EventEmitter from '../../../utils/EventEmitter';
import { CurrencyService } from '../tien-te/CurrencyService';
import { DialogViewHistory } from './component/DialogViewHistory';
export const List = () => {

  const header = 'Hàng hóa, dịch vụ';
  const dataKey = 'id';
  const [displayHistoryItem, setDisplayHistoryItem] = useState(null);
  const [displayHistory, setDisplayHistory] = useState(false);

  const [formatPrice, setFormatPrice] = useState(0);

  const [units, setUnits] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [manyActions, setManyActions] = useState([]);

  useEffect(() => {
    UnitService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({ items }) => {
      const _units = [];
      items.forEach(item => {
        _units.push({ value: item.id, label: item.name });
      });
      setUnits(_units);
    });
    TaxService.getList({}).then(({ items }) => {
      const _taxs = [];
      items.forEach((item) => {
        _taxs.push({ value: item.id, label: item.name, ratio: item.ratio });
      });
      setTaxs(_taxs);
    });
    CurrencyService.getList({}).then(({ items }) => {
      if (items?.length) {
        const currency = items.find(it => it.code === 'VND');
        if (currency) {
          setFormatPrice(currency.formatPrice || 0);
        }
      }
    });
  }, []);

  useEffect(() => {
    const eventsChangeSerial = EventEmitter.addListener("changeTaxs", changeTaxs);
    return () => {
      eventsChangeSerial.removeListener("changeTaxs", changeTaxs);
    }
  });

  const changeTaxs = (changeTaxsData) => {
    Service.updateChangeTax(changeTaxsData).then(res => {
      refreshLazyData();
    });
  }

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'order', header: 'Thứ tự', width: 80, matchMode: 'contains' },
      { field: 'code', header: 'Mã hàng hóa', width: 200, matchMode: 'contains' },
      { field: 'name', header: 'Tên hàng hóa', minWidth: 220, matchMode: 'contains' },
      {
        field: 'taxId', header: 'Thuế suất', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: taxs, dataType: 'custom', customCell(rowData: any): any {
          return rowData.taxName;
        }
      },
      {
        field: 'price', header: 'Giá bán niêm yết', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.priceWithVat, { maximumSignificantDigits: `${rowData.priceWithVat}`.length })
        }, style: { justifyContent: 'end' }
      },
      {
        field: 'price', header: 'Giá bán', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.price, { maximumSignificantDigits: `${rowData.price}`.length })
        }, style: { justifyContent: 'end' }
      },
      { field: 'prices', header: 'Danh sách mệnh giá', minWidth: 220, matchMode: 'contains' },
      { field: 'unit', header: 'Đơn vị tính', width: 160, matchMode: 'contains' },
      { field: 'isUse', header: 'Sử dụng trên app mobile', width: 180, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean' },
      {
        field: '', header: 'Thao tác', width: 80, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <div>
              <i className="p-button-icon p-c pi pi-clock" onClick={() => viewHistory(rowData)}></i>
            </div>
          );
        }, style: { justifyContent: 'center' }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });
  const viewHistory = (item) => {
    setDisplayHistoryItem(item);
    setDisplayHistory(true);
  };
  useEffect(() => {
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  const { render: renderDialogCrup, create, update, clone, getValue, setValue, touched } = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      { field: 'code', header: 'Mã hàng hóa', required: true, disabled: 'onlyUpdate', uppercase: true, InputTextProps: { maxLength: 50 }, className: 'md:col-12' },
      { field: 'name', header: 'Tên hàng hóa', required: true, InputTextProps: { maxLength: 500 }, className: 'md:col-12' },
      { field: 'unitId', header: 'Đơn vị tính', type: 'Dropdown', DropdownProps: { options: units, filter: true }, className: 'md:col-6' },
      { field: 'taxId', header: 'Thuế suất', type: 'Dropdown', DropdownProps: { options: taxs, filter: true }, className: 'md:col-6' },
      { field: 'priceWithVat', header: 'Giá bán niêm yết (Đã bao gồm Thuế GTGT)', required: true, type: 'InputNumber', InputNumberProps: { min: 0 }, className: 'md:col-12' },
      { field: 'price', header: 'Giá bán trên hóa đơn', required: true, type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: formatPrice }, className: 'md:col-6' },
      { field: 'order', header: 'Thứ tự', required: true, type: 'InputNumber', InputNumberProps: { min: 0 }, className: 'md:col-6' },
      { field: 'prices', header: 'Danh sách mệnh giá', required: true, InputTextProps: { maxLength: 550 }, className: 'md:col-12' },
      { field: 'isUse', header: 'Sử dụng trên app mobile', type: 'Checkbox', className: "md:col-12" }
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { taxId, priceWithVat } = getValue();

  useEffect(() => {
    if (touched) {
      const _value = getValue();
      _value.price = 0;
      if (priceWithVat > 0) {
        _value.price = priceWithVat;
      }
      if (taxId) {
        const ratio = taxs.find(it => it.value === taxId)?.ratio;
        if (priceWithVat > 0 && ratio > 0) {
          _value.price = formatNumber(priceWithVat / (1 + ratio / 100), formatPrice);
        }
      }
      setValue(_value);
    }
  }, [taxId, priceWithVat]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatNumber = (number: any, fraction?: number) => {
    if (typeof number === 'number') {
      if (!Number.isFinite(number) || Number.isNaN(number)) {
        number = 0;
      }
      if (`${number}`.length > 2 && `${number}`.split('.').length) {
        number = 1 * number.toPrecision(`${number}`.split('.')[0].length + fraction || 2);
      }
    }
    return number;
  }


  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey, create,
    update: (item) => {
      Service.get(item[dataKey]).then(data => {
        if (!data.priceWithVat) {
          if (data.price > 0) {
            data.priceWithVat = data.price;
          }
          if (data.ratioTax > 0 && data.price > 0) {
            data.priceWithVat = Math.round(data.price * (1 + data.ratioTax / 100));
          }
        }
        update(data);
      });
    },
    clone: (item) => {
      Service.get(item[dataKey]).then(data => {
        clone(data);
      });
    },
    reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    deleteItems(ids) {
      return Service.deleteMulti(ids);
    },
    otherActions: [
      ...manyActions,
    ]
  });

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({ id }) => id);
    }

    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
      ConfirmDialogService.showInvalid('Bạn cần chọn hàng hóa trước khi sửa');
      return;
    }
  }

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      <DialogViewHistory display={displayHistory} setDisplay={setDisplayHistory} selectedItem={displayHistoryItem} />
    </Fragment>
  )
}
